<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body v-if="checkAccessPrivilege('JeetPrivilege.MemberLevel.Search')">
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sUsername">Username </label>
              <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
              &nbsp;&nbsp;
              <label class="mx-sm-2" for="sMemberLevel">Level </label>
              <b-form-select id="sMemberLevel" :plain="true" :options="filteredLevels" v-model="sMemberLevel" text-field="DisplayName" value-field="Level">
                <template slot="first">
                  <option :value="null">-- Please select an option --</option>
                </template>
              </b-form-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="searchMemberLevel"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-user'></i> Member Level</h3>
              <div class="float-right">
                <b-button variant="danger" @click="exportCSV">Export CSV</b-button>
                <b-button variant="primary" @click="showManagementModal" v-if="checkAccessPrivilege('JeetPrivilege.MemberLevel.Management')">Level Management</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <!-- <template v-slot:cell(Level)="data">
                <span v-if="data.item.Level === 1">Bronze</span>
                <span v-else-if="data.item.Level === 2">Silver</span>
                <span v-else-if="data.item.Level === 3">Gold</span>
                <span v-else-if="data.item.Level === 4">Pearl</span>
                <span v-else-if="data.item.Level === 5">Ruby</span>
                <span v-else-if="data.item.Level === 6">Kohinoor</span>
              </template> -->
              <template v-slot:cell(action)="data">
                <b-button variant="warning" @click="showChangeMemberLevel(data.item.Id, data.item.Level, data.item.MemberId, data.item.Username)" v-if="checkAccessPrivilege('JeetPrivilege.MemberLevel.Change')">Change</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="changeMemberLevel" size="lg" centered header-bg-variant="primary" hide-footer title="Change Member Level">
          <div class="mb-3">
            <label for="cMemberLevel">Level</label>
            <b-form-select id="cMemberLevel" :plain="false" v-model="cMemberLevel" :state="$v.cMemberLevel.$error?false:null" @blur.native="$v.cMemberLevel.$touch">
              <option :value="null">-- Please select --</option>
              <option v-for="d in levels" :value="d.Level" :key="d.Name">{{ d.Name }}</option>
            </b-form-select>
            <div v-if="$v.cMemberLevel.$error">
              <div class="invalid-feedback d-block" v-if="!$v.cMemberLevel.required">Member level is required</div>
            </div>
          </div>
          <div class="mb-3">
            <label class="mx-sm-2" for="cOperatorPasswd">Operator Password </label>
            <b-input id="cOperatorPasswd" type="password" placeholder="" v-model="cOperatorPasswd" :state="$v.cOperatorPasswd.$error?false:null" @blur.native="$v.cOperatorPasswd.$touch"></b-input>
            <div v-if="$v.cOperatorPasswd.$error">
              <div class="invalid-feedback d-block" v-if="!$v.cOperatorPasswd.required">Operator Password is required</div>
            </div>
          </div>
          <b-button variant="success" @click="changeMemberLevel" :disabled="$v.cMemberLevel.$invalid || $v.cOperatorPasswd.$invalid">Confirm</b-button>
          <b-button variant="outline-danger" @click="cancelChangeMemberLevel">Cancel</b-button>
    </b-modal>
    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="Member Level Management">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!$v.searchName.$error">
                      <b-input-group>
                        <b-form-input type="text" placeholder="Enter Username for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                        <b-input-group-button class="input-group-append">
                          <b-btn variant="success" @click="searchMember" :disabled="$v.searchName.$invalid">
                            <i class="fa fa-search"></i> Search
                          </b-btn>
                        </b-input-group-button>
                      </b-input-group>
                      <div v-if="$v.searchName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Username is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="members" :fields="memberFields" :current-page="memberCurrentPage" :per-page="memberPerPage">
                      <template v-slot:cell(action)="data">
                        <b-button variant="danger" @click="confirmAssignLevel(data.item.Id, data.item.Username)">Assign</b-button>
                      </template>
                    </b-table>
                    <nav>
                      <b-pagination :total-rows="getMemberRowCount(members)" :per-page="memberPerPage" v-model="memberCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>
    <b-modal ref="confirmAssignLevel" @hidden="onAssignModalHide" size="lg" centered header-bg-variant="primary" hide-footer title="Assign Member Level">
          <div class="mb-3">
            <label for="aMemberLevel">Level</label>
            <b-form-select id="aMemberLevel" :plain="false" v-model="aMemberLevel" :state="$v.aMemberLevel.$error?false:null" @blur.native="$v.aMemberLevel.$touch">
              <option :value="null">-- Please select --</option>
              <option v-for="d in levels" :value="d.Level" :key="d.Name">{{ d.Name }}</option>
            </b-form-select>
          </div>
          <div class="mb-3">
            <label class="mx-sm-2" for="aOperatorPasswd">Operator Password </label>
            <b-input id="aOperatorPasswd" type="password" placeholder="" v-model="aOperatorPasswd" :state="$v.aOperatorPasswd.$error?false:null" @blur.native="$v.aOperatorPasswd.$touch"></b-input>
            <div v-if="$v.aOperatorPasswd.$error">
              <div class="invalid-feedback d-block" v-if="!$v.aOperatorPasswd.required">Operator Password is required</div>
            </div>
          </div>
          <b-button variant="success" @click="assignMemberLevel" :disabled="$v.aMemberLevel.$invalid || $v.aOperatorPasswd.$invalid">Confirm</b-button>
          <b-button variant="outline-danger" @click="cancelAssignLevel">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  const moment = require('moment-timezone')
  export default {
    name: 'member-level-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        members: [],
        levels: [],
        filteredLevels: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'DisplayName', label: 'Level'},
          {key: 'action', label: 'Action'}
        ],
        memberFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        memberCurrentPage: 1,
        perPage: 10,
        memberPerPage: 10,
        totalMemberRows: 0,
        operator: '',
        searchName: '',
        changeId: '',
        oMemberLevel: '',
        cMemberId: '',
        cMemberUsername: '',
        cMemberLevel: null,
        cOperatorPasswd: '',
        sUsername: '',
        sMemberLevel: null,
        assignId: '',
        assignUsername: '',
        aMemberLevel: null,
        aOperatorPasswd: ''
      }
    },
    validations: {
      searchName: { required, minLength: minLength(5), maxLength: maxLength(20) },
      cMemberLevel: { required },
      cOperatorPasswd: { required },
      aMemberLevel: { required },
      aOperatorPasswd: { required }
    },
    watch: {
      currentPage: function () {
        this.searchMemberLevel()
      },
      currentMemberPage: function () {
        this.searchMember()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getMemberRowCount (members) {
        return members.length
      },
      getMemberLevels () {
        this.$http.get(this.API_ENDPOINT + '/jeetprivilege/member/levels', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.levels = response.data.levels
          this.filteredLevels = response.data.levels.filter(x => x.Level !== 1)
          console.log(this.filteredLevels)
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllMemberLevelData () {
        this.$http.get(this.API_ENDPOINT + '/jeetprivilege/member/level/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchMember () {
        this.$http.post(this.API_ENDPOINT + '/member/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.members = response.data.members
          this.totalMemberRows = response.data.members.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchMemberLevel () {
        let username = this.sUsername
        let memberLevel = this.sMemberLevel
        if (username === '' && memberLevel === null) {
          this.getAllMemberLevelData()
          return
        }
        let queryStr = `?username=${username}&level=${(memberLevel === null) ? '' : memberLevel}`
        this.$http.get(this.API_ENDPOINT + '/jeetprivilege/member/level/search' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      changeMemberLevel () {
        this.$http.post(this.API_ENDPOINT + '/jeetprivilege/member/level/set', {'id': this.changeId, 'newLevel': this.cMemberLevel, 'oldLevel': this.oMemberLevel, 'memberId': this.cMemberId, 'username': this.cMemberUsername, 'operator': this.operator, 'password': this.cOperatorPasswd}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchMemberLevel()
            this.cancelChangeMemberLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Member Level Changed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      assignMemberLevel () {
        this.$http.post(this.API_ENDPOINT + '/jeetprivilege/member/level/assign', {'memberId': this.assignId, 'username': this.assignUsername, 'level': this.aMemberLevel, 'operator': this.operator, 'password': this.aOperatorPasswd}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchMemberLevel()
            this.cancelAssignLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Member Level Assigned')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      exportCSV () {
        let username = this.sUsername
        let memberLevel = this.sMemberLevel
        let queryStr = `?username=${username}&level=${(memberLevel === null) ? '' : memberLevel}`
        this.$http.get(this.API_ENDPOINT + '/jeetprivilege/member/level/search/export' + queryStr, { responseType: 'blob', headers: { 'Content-Type': 'application/json' } }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `member_tier_level_${moment().format('YYYYMMDDHHMM')}.csv`)
          document.body.appendChild(link)
          link.click()
        })
      },
      showChangeMemberLevel (id, level, memberId, username) {
        this.changeId = id
        this.oMemberLevel = level
        this.cMemberLevel = level
        this.cMemberId = memberId
        this.cMemberUsername = username
        this.$refs.changeMemberLevel.show()
      },
      cancelChangeMemberLevel () {
        this.$refs.changeMemberLevel.hide()
        this.cMemberLevel = null
        this.cOperatorPasswd = ''
        this.$v.cMemberLevel.$reset()
        this.$v.cOperatorPasswd.$reset()
      },
      showManagementModal () {
        this.$refs.showManagementModal.show()
      },
      hideManagementModal () {
        this.$refs.showManagementModal.hide()
      },
      confirmAssignLevel (id, username) {
        this.assignId = id
        this.assignUsername = username
        this.$refs.confirmAssignLevel.show()
      },
      cancelAssignLevel () {
        this.$refs.confirmAssignLevel.hide()
        this.aMemberLevel = null
        this.aOperatorPasswd = ''
        this.$v.aMemberLevel.$reset()
        this.$v.aOperatorPasswd.$reset()
      },
      onAssignModalHide () {
        this.$refs.showManagementModal.show()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
      this.getMemberLevels()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/memberLevel/MemberLevelTable.vue